export async function computeVersion(text: string): Promise<string> {
	try {
		if (
			typeof crypto !== "undefined" &&
			crypto.subtle &&
			typeof TextEncoder !== "undefined"
		) {
			const enc = new TextEncoder().encode(text);
			const buf = await crypto.subtle.digest("SHA-256", enc);
			const hashArray = Array.from(new Uint8Array(buf));
			const hashHex = hashArray
				.map((b) => b.toString(16).padStart(2, "0"))
				.join("");
			return hashHex.slice(0, 12);
		}
	} catch {}
	let h = 0;
	for (let i = 0; i < text.length; i++) {
		h = (h * 31 + text.charCodeAt(i)) >>> 0;
	}
	return ("00000000" + h.toString(16)).slice(-8);
}
